import { useState } from "react";

const IconSelection = ({ setSelection, setIconUrl }) => {
  const icons = [
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb1.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb2.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb3.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb4.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb5.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb6.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb7.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb8.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb9.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb10.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Academy/PAE/btn/bulb11.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Shubham/Education/btnvid-blue.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Shubham/Education/btnlang-blue.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Interlude/CPicons/bulb1.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Interlude/CPicons/violincolor.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Interlude/CPicons/video-orange.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Interlude/CPicons/_perc/simple-snare.svg",
    "https://d9fedpdsh4r16.cloudfront.net/Interlude/CPicons/_perc/simple-marimba.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-neutral.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-b.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-bl.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-br.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-l.svg ",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-r.svg ",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-t.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-t.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-tr.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icono-tl.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Activity.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Assessment.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Audio-comment.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/External-link.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Flash-cards.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Image-gallery.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Question.svg",
    "https://d9fedpdsh4r16.cloudfront.net/misc/heresMexico/Video-comment.svg",
    "https://dpi-assets.s3.us-east-2.amazonaws.com/misc/heresMexico/Location2.svg",
    "https://dpi-assets.s3.us-east-2.amazonaws.com/misc/heresMexico/Location5.svg",
  ];

  return (
    <div>
      <div>IconSelection</div>

      <div style={{ maxWidth: "350px" }}>
        {icons.map((icon, index) => (
          <button
            key={index}
            onClick={() => {
              setSelection(icon);
              setIconUrl(icon);
            }}
          >
            <img src={icon} alt="icon" style={{ height: 75, width: 75 }} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default IconSelection;
